"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tealiumTags = exports.robotsStatus = exports.pageUri = exports.pageCanonical = exports.getSocialShareUrl = exports.getRootUrl = void 0;
var _lodash = require("lodash");
var _utils = require("../utils");
/**
 * Get Tealium tags
 *
 * @param {*} props Analytics fields
 * @returns {string} comma separated Tealium tags
 */
var tealiumTags = props => {
  var utagData = props.initialUtags;
  utagData.site_id = "".concat(props.utagSiteName);
  if (props.app === 'mmcom' && props.pageCategory === 'Search') {
    var getURLQuery = new URLSearchParams(props.pageQuery);
    utagData.search_term = getURLQuery.get('query');
  }
  if (props.addUtagLoginCookie) {
    var auth0Cookie = (0, _utils.getCookieValue)('auth0LoggedIn');
    var loginCookie = auth0Cookie ? 'true' : 'false';
    if (!auth0Cookie) auth0Cookie = 'false';
    utagData.loggedIn = loginCookie;
    utagData.csspCustomer = auth0Cookie;
    utagData.auth0LoggedIn = loginCookie;
    utagData.auth0UserType = auth0Cookie;
  }
  var env = !props.env || (0, _lodash.isEmpty)(props.env) || props.env === 'local' ? 'dev' : props.env;
  return {
    context: {
      env: "".concat(env)
    },
    utags: utagData
  };
};

/**
 * Get SEO Meta Robot status
 *
 * @param {*} props robotsNoIndex, robotsNoFollow
 * @returns {string} na if no robot, else based on robots status
 */
exports.tealiumTags = tealiumTags;
var robotsStatus = props => {
  if (props.robotsNoIndex) return props.robotsNoFollow ? 'noindex, nofollow' : 'noindex';else if (props.robotsNoFollow) return 'nofollow';else return 'na';
};
/**
 * Get Current Page URL
 *
 * @param {*} props Page Location Path
 * @returns {string} Current Page URL
 */
exports.robotsStatus = robotsStatus;
var pageUri = props => {
  return (0, _utils.getMMDomainUrl)(props.pagePath);
};
/**
 * Get Current Page Canonical URL
 *
 * @param {*} props Page Location Path
 * @returns {string} Current Page Canonical URL
 */
exports.pageUri = pageUri;
var pageCanonical = props => {
  var pagePath = props.pagePath;
  if (!(0, _lodash.isEmpty)(props.pageQuery)) {
    var queryString = props.pageQuery.split('?').pop();
    queryString = queryString.split('&');
    var newQueryString = '';
    queryString.map(param => {
      var paramQuery = param.split('=');
      if (paramQuery.length > 0) {
        if (paramQuery[0].toLowerCase() === 'page' && paramQuery[1].length >= 2) {
          if ((0, _lodash.isEmpty)(newQueryString)) newQueryString = param;else newQueryString = newQueryString + '&' + param;
        }
      }
    });
    pagePath = (0, _lodash.isEmpty)(newQueryString) ? pagePath : pagePath + '?' + newQueryString;
  }
  return (0, _utils.getMMDomainUrl)(pagePath);
};
exports.pageCanonical = pageCanonical;
var getSocialShareUrl = props => {
  var url = "";
  if (!(0, _lodash.isEmpty)(props.linkUrl)) {
    url = (0, _lodash.replace)(props.linkUrl, "{pageurl}", (0, _utils.getMMDomainUrl)(props.pagePath));
    url = (0, _lodash.replace)(url, "{metatitle}", props.metaTitle);
    url = (0, _lodash.replace)(url, "{metadescription}", props.metaDescription);
  }
  return encodeURI(url);
};

/**
 * Returns Web content api URL
 *
 * @param {*} env App environment
 *
 * @returns {string} relative or abosulte mm com url per environment
 */
exports.getSocialShareUrl = getSocialShareUrl;
var getRootUrl = env => {
  if (env === null || typeof env === 'undefined' || env === 'prod') return 'www.massmutual.com';else if (env === 'preview') return 'www2.massmutual.com';else if (env === 'qa') return 'www-qa.massmutual.com';else return 'www-dev.massmutual.com';
};
exports.getRootUrl = getRootUrl;